<script>
export default {
  methods: {
    LocalStorage(name, set = new Object()) {
      var taskArrayString = localStorage.getItem(name);
      if (taskArrayString !== null && typeof taskArrayString === "string") {
        // console.log("Succesfully retrieved 'tasks' and contents.");
      } else {
        // console.log("Succesfully retrieved 'tasks', contents were not a string or held no contents. Contents of 'tasks' reset to empty object");
        var emptyArray = JSON.stringify(set);
        localStorage.setItem(name, emptyArray);
        taskArrayString = localStorage.getItem(name);
      }
      return JSON.parse(taskArrayString);
    },
    redirect(path) {
      if (this.$route.path !== path) this.$router.push(path)
    },
    onImgLoad(target) {
      const img = target.path[0];
      const div = target.path[1];
      // console.log(target,div,img,img.width,img.height,img.naturalWidth>img.naturalHeight);
      if (img.naturalWidth > img.naturalHeight) {
        div.classList.add("col-sm-4");
      } else {
        div.classList.add("col-sm-2");
      }
    },
  },
};
</script>
